(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Maison-Journal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const REVEAL_SELECTOR = '.maison-journal__reveal';
    const VISIBLE_CLASS = 'maison-journal__reveal--visible';

    /**
     * Reveals matching elements with a fade/slide-up transition as
     * they enter the viewport. Falls back to showing everything
     * immediately if IntersectionObserver is unavailable.
     */
    function initMaisonJournalReveal() {
      const items = document.querySelectorAll(REVEAL_SELECTOR);

      if (items.length === 0) {
        return;
      }

      if (!('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add(VISIBLE_CLASS));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add(VISIBLE_CLASS);
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );

      items.forEach((item) => observer.observe(item));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMaisonJournalReveal);
    } else {
      initMaisonJournalReveal();
    }

    document.addEventListener('shopify:section:load', initMaisonJournalReveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    // Auto-submits the country/region selector when it changes, since
    // it is a single control with no separate "Update" button.
    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-maison-footer-auto-submit]')) {
        event.target.closest('form').submit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
